import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';
// mui components
import { Box, Grid } from '@mui/material';
// components
import Role from 'components/file-cabinet-folders/modals/components/role';
// api
import { IFolder } from 'redux-store/api/file-cabinet';
import { isCustomProjectFolder } from 'utils/helpers/fileCabinetHelpers';
// styles
import { styles } from '../users/styles';

type Props = {
  folder?: IFolder;
  forceShow?: boolean;
  adminCheckedByDefault?: boolean;
};

const CompanyRolesTable: FC<Props> = ({
  folder,
  forceShow = false,
  adminCheckedByDefault = false,
}) => {
  const { watch } = useFormContext();

  const fields = watch('roles');

  if (!forceShow && !isCustomProjectFolder(folder)) {
    return null;
  }

  return (
    <Box sx={{ marginTop: '24px' }}>
      <Box sx={styles.usersContainer}>
        <Grid sx={styles.rolesTableHead}>
          <Grid sx={styles.roleTableTitle}>Role</Grid>
          <Grid sx={styles.roleTableItem}>View</Grid>
          <Grid sx={styles.roleTableItem}>Add/Edit</Grid>
          <Grid sx={styles.roleTableItem}>Delete</Grid>
        </Grid>

        {fields?.map((role, index) => (
          <Role
            adminCheckedByDefault={adminCheckedByDefault}
            key={role.id}
            role={role}
            index={index}
          />
        ))}
      </Box>
    </Box>
  );
};

export default CompanyRolesTable;
